<template>
    <div>
        <div class="menu-title">
            默认设备管理
        </div>
        <div class="menu-content">
            <div>
                <el-form  :inline="true" :model="qo" size="small" class="demo-form-inline">
                  <el-form-item label="微信版本：">
                    <el-input v-model="qo.LIKES_wxMpVersion" placeholder="请输入微信版本" style="width: 300px"></el-input>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="success" icon="el-icon-search" @click="qo.pageNo=1;queryData()">搜 索</el-button>
                  </el-form-item>
                </el-form>
            </div>
            <div style="margin: 0px 0 20px 0">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="createRow()">添加</el-button>
            </div>
            <div class="table-list">
                <el-table :data="result.records" style="width: 100%" >
                    <el-table-column type="index" label="序号" width="100" ></el-table-column>
                    <el-table-column prop="wxMpVersion" label="微信版本" ></el-table-column>
                    <el-table-column prop="deviceCode" label="设备号" ></el-table-column>
                    <el-table-column prop="bindingVersion" label="绑定版本" ></el-table-column>
                    <el-table-column prop="open" label="是否开启" width="120" >
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.open" :disabled="true"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="160">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="modifyRow(scope.row)"  type="text" size="small">
                                编辑
                            </el-button>
                            <el-button @click.native.prevent="removeRow(scope.row)"  type="text" size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-box">
                <el-pagination background
                               @current-change="handleCurrentChange"
                               :current-page="qo.pageNo"
                               :page-size="qo.pageSize"
                               :page-sizes="[10,20,30,40,50]" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next"
                               :total="result.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false"
                :title="dialogName"
                :visible.sync="cmdDialogVisible"
                width="40%">
            <el-form ref="cmd" label-width="80px" :rules="rules" :model="cmd">
                <el-form-item label="微信版本" prop="wxMpVersion">
                    <el-input v-model="cmd.wxMpVersion" placeholder="请输入微信版本"></el-input>
                </el-form-item>
                <el-form-item label="设备号" prop="deviceCode">
                    <el-input v-model="cmd.deviceCode" placeholder="请输入设备号"></el-input>
                </el-form-item>
                <el-form-item label="绑定版本" prop="bindingVersion">
                    <el-input v-model="cmd.bindingVersion" placeholder="请输入绑定版本"></el-input>
                </el-form-item>
                <el-form-item label="是否开启" prop="open">
                    <el-switch v-model="cmd.open"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cmdDialogVisible = false"  size="small">取 消</el-button>
                <el-button type="primary" @click="submitModify"  size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request from '@/utils/request';

    var _this;
    export default {
        name: "wxMpDefaultDeviceManage",
        data() {
            return {
                qo: {
                    pageNo: 1,
                    pageSize: 10,
                    LIKES_wxMpVersion: '',
                    DESCI_createTime:1,
                },
                result: {
                    records: [],
                    total: 0
                },
                dialogName: '编辑',
                cmdDialogVisible: false,
                cmd: {},
                rules: {
                    wxMpVersion: [
                        {required: true, message: '请输入微信版本'},
                    ],
                    deviceCode: [
                        {required: true, message: '请输入设备号'},
                    ],
                },
            }
        },
        mounted() {
            _this = this;
            _this.queryData();
        },
        methods: {
            queryData() {
                request({
                    url: '/core/wx-mp-default-device/query_pages',
                    method: 'post',
                    data: _this.qo
                }).then(res => {
                    _this.result.records = res.records;
                    _this.result.total = res.total;
                });
            },
            handleCurrentChange(val) {
                _this.qo.pageNo = val;
                _this.queryData();
            },
            handleSizeChange(val) {
                _this.qo.pageNo = 1;
                _this.qo.pageSize = val;
                _this.queryData();
            },
            removeRow(item) {
                _this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    request({
                        url: '/core/wx-mp-default-device/remove/' + item.id,
                        method: 'post'
                    }).then(res => {
                        _this.$message.success("删除成功");
                        _this.queryData();
                    });
                }).catch(() => {
                });
            },
            createRow() {
                _this.dialogName = '添加';
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    _this.cmd = {
                        wxMpVersion:"",
                        deviceCode:"",
                        open:false,
                        bindingVersion:""
                    };
                    _this.$refs.cmd.resetFields();
                });
            },
            modifyRow(item) {
                _this.dialogName = '编辑';
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    _this.cmd = JSON.parse(JSON.stringify(item));
                    _this.$refs.cmd.resetFields();
                });
            },
            submitModify() {
                this.$refs.cmd.validate((valid) => {
                    if (valid) {
                        if (_this.cmd.id && _this.cmd.id.toString.length > 0) {
                            request({
                                url: '/core/wx-mp-default-device/modify',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("编辑成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        } else {
                            request({
                                url: '/core/wx-mp-default-device/create',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("添加成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        }
                    }
                });
            },
        }
    }
</script>

<style  lang="scss">
</style>
